import { useLayoutEffect, useState } from "react";
import { useAtomValue } from "jotai";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  activeVendorAtom,
  clearVendorCreds,
  enrolledVendorsAtom,
  VendorId,
  VENDOR_IDS,
  VENDOR_LABEL,
  vendorAccountsAtom,
} from "./vendor";
import { switchToVendor } from "./bootAuth";
import { Header, Page, Section, Button } from "./components";
import { navigate } from ".";

export function Accounts() {
  const enrolled = useAtomValue(enrolledVendorsAtom);
  const activeVendor = useAtomValue(activeVendorAtom);
  const accounts = useAtomValue(vendorAccountsAtom);

  useLayoutEffect(() => {
    if (enrolled.length === 0) navigate("/auth");
  }, [enrolled.length]);

  if (enrolled.length === 0) return null;

  return (
    <Page>
      <Header />
      <Section>
        <div className="w-full flex flex-row items-center gap-2 mb-4">
          <button
            className="text-text-secondary cursor-pointer flex items-center"
            aria-label="back"
            onClick={() => navigate("/")}
          >
            <ArrowBackIcon fontSize="medium" />
          </button>
          <h1 className="text-xl text-text-secondary">accounts</h1>
        </div>
        <div className="w-full flex flex-col gap-3">
          {enrolled.map((v) => (
            <AccountRow
              key={v}
              vendor={v}
              active={v === activeVendor}
              subLabel={
                accounts[v]?.profile?.email ??
                accounts[v]?.creds.username ??
                ""
              }
            />
          ))}
        </div>
        {enrolled.length < VENDOR_IDS.length && (
          <div className="mt-6">
            <Button
              fullWidth
              textClass="text-lg"
              onClick={() => navigate("/auth")}
            >
              add account
            </Button>
          </div>
        )}
      </Section>
    </Page>
  );
}

function AccountRow(props: {
  vendor: VendorId;
  active: boolean;
  subLabel: string;
}) {
  const [confirming, setConfirming] = useState(false);

  const onLogout = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!confirming) {
      setConfirming(true);
      return;
    }
    clearVendorCreds(props.vendor);
    setConfirming(false);
  };

  const onRowClick = () => {
    if (confirming) return;
    if (!props.active) switchToVendor(props.vendor);
    navigate("/");
  };

  return (
    <div
      className={
        "w-full rounded p-5 bg-bg-brand-alt text-text-on-brand-alt " +
        (confirming ? "" : "cursor-pointer hover:opacity-90")
      }
      onClick={onRowClick}
      role={confirming ? undefined : "button"}
    >
      <div className="flex flex-row items-start justify-between gap-4">
        <div className="flex flex-col min-w-0">
          <div className="text-base text-text-secondary truncate">
            {VENDOR_LABEL[props.vendor]}
            {props.active && (
              <span className="ml-2 text-text-secondary">(current)</span>
            )}
          </div>
          <div className="text-2xl truncate mt-1">{props.subLabel}</div>
        </div>
        <button
          className="w-20 shrink-0 text-lg underline decoration-dotted text-right"
          onClick={onLogout}
        >
          {confirming ? "confirm" : "logout"}
        </button>
      </div>
    </div>
  );
}
